(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'om-favs';
  function getFavs() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setFavs(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paintFavs() {
    var f = getFavs();
    document.querySelectorAll('[data-om-fav]').forEach(function (b) {
      var on = f.indexOf(b.dataset.omFav) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
  }
  function setCount(n) {
    document.querySelectorAll('[data-om-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  document.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-om-fav]');
    if (fav) {
      e.preventDefault();
      var f = getFavs(), h = fav.dataset.omFav, i = f.indexOf(h);
      if (i > -1) f.splice(i, 1); else f.push(h);
      setFavs(f); paintFavs();
      return;
    }
    var add = e.target.closest('[data-om-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      add.disabled = true;
      var label = add.innerHTML;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +add.dataset.omAdd, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCount(cart.item_count);
          add.textContent = 'Sepete eklendi ✓';
          add.classList.add('is-done');
          document.dispatchEvent(new CustomEvent('om:cart-updated', { detail: cart }));
        })
        .catch(function () { add.textContent = 'Eklenemedi, tekrar dene'; })
        .finally(function () {
          setTimeout(function () { add.innerHTML = label; add.disabled = false; add.classList.remove('is-done'); }, 2000);
        });
    }
  });

  paintFavs();
  document.addEventListener('om:favs-rendered', paintFavs);
})();
/* Sepet notunu ödeme sayfasında da göster: ilk ürünün altına "Sipariş notu" olarak ekle */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
  if (!btn || btn.dataset.omNoteDone) return;
  var ta = document.querySelector('textarea[name="note"]');
  if (!ta) return;
  var note = ta.value.trim();
  e.preventDefault();
  e.stopPropagation();
  btn.dataset.omNoteDone = '1';
  var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ note: note }) })
    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
    .then(function (cart) {
      var first = cart.items[0];
      if (!first) return;
      var props = Object.assign({}, first.properties || {});
      if (note) props['Sipariş notu'] = note; else delete props['Sipariş notu'];
      return fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: first.key, quantity: first.quantity, properties: props }) });
    })
    .catch(function () {})
    .then(function () { window.location.href = '/checkout'; });
}, true);